import { GlobalAxios } from "../axios/axios-config";
import {
  IAddToExistingList,
  IConvertList,
  IUploadExcel,
} from "../models/list-import-batch";

const BASE_URL = process.env.REACT_APP_MAIN + "/api/v1/ListImportBatch/";

const UPLOAD_EXCEL_URL = BASE_URL + "uploadExcel";

const CONVERT_LIST_ROUTE = BASE_URL + "convertinlist";

const ADD_TO_EXISTING_LIST_ROUTE = BASE_URL + "addtoexistinglist";

const DEFINE_ROUTE = BASE_URL + "Define";

export class ListImportBatchService {
  uploadExcel = (params: IUploadExcel) => {
    const formData = new FormData();

    formData.append("file", params.file);
    params.porpouseIds.map((id) => formData.append("porpouseIds", id));
    if (params.integrationTypeId) {
      formData.append("integrationTypeId", params.integrationTypeId);
    }
    if (params.listClassificationId) {
      formData.append("listClassificationId", params.listClassificationId);
    }

    return GlobalAxios.post(UPLOAD_EXCEL_URL, formData);
  };

  convertList = (params: IConvertList) => {
    return GlobalAxios.post(CONVERT_LIST_ROUTE, params);
  };

  addToExistingList = (params: IAddToExistingList) => {
    return GlobalAxios.post(ADD_TO_EXISTING_LIST_ROUTE, params);
  };

  define = (id: string) => {
    return GlobalAxios.put(DEFINE_ROUTE + "/" + id);
  };
}
